// extracted by mini-css-extract-plugin
module.exports = {"noAuthLayout":"NoAuthLayout_noAuthLayout__1tI8-","column":"NoAuthLayout_column__24f57","left":"NoAuthLayout_left__4g_ZG","right":"NoAuthLayout_right__2WbFQ"};